import { Component, ChangeDetectionStrategy } from "@angular/core";
import { AgRendererComponent } from "ag-grid-angular";
import { HiringOutcome } from "../../core/enums/hiring-outcome.enum";

@Component({
  selector: "app-checkbox-view-renderer",
  template: `
    Hired:
    <input name="outcomeHired" type="checkbox" [checked]="outcomeHired" (change)="onChange($event)" />
    |
    Not Hired:
    <input name="outcomeNotHired" type="checkbox" [checked]="outcomeNotHired" (change)="onChange($event)" />
    |
    Pending:
    <input name="pending" type="checkbox" [checked]="pending" (change)="onChange($event)" />
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CheckboxViewRendererComponent implements AgRendererComponent {
  private params: any;

  public outcomeHired = false;
  public outcomeNotHired = false;
  public pending = false;

  agInit(params: any): void {
    this.params = params;
    this.syncFromBestSource();
  }

  refresh(params: any): boolean {
    this.params = params;
    this.syncFromBestSource();
    return true;
  }

  private syncFromBestSource() {
    const parent = this.params?.context?.componentParent;
    const cached = parent?.cachedOutcomeUpdates?.get?.(this.params.data.assessmentRequestId);

    const outcome =
      cached?.hiringOutcome ??
      this.params.data.hiringOutcome ??
      HiringOutcome.NotYetAnswered;

    this.outcomeHired = outcome === HiringOutcome.Hired;
    this.outcomeNotHired = outcome === HiringOutcome.NotHired;
    this.pending = outcome === HiringOutcome.Pending;
  }

  onChange(event: any) {
    let hiringOutcome: number = HiringOutcome.NotYetAnswered;

    switch (event.target.name) {
      case "outcomeHired":
        hiringOutcome = event.target.checked ? HiringOutcome.Hired : HiringOutcome.NotYetAnswered;
        break;
      case "outcomeNotHired":
        hiringOutcome = event.target.checked ? HiringOutcome.NotHired : HiringOutcome.NotYetAnswered;
        break;
      case "pending":
        hiringOutcome = event.target.checked ? HiringOutcome.Pending : HiringOutcome.NotYetAnswered;
        break;
    }

    this.outcomeHired = hiringOutcome === HiringOutcome.Hired;
    this.outcomeNotHired = hiringOutcome === HiringOutcome.NotHired;
    this.pending = hiringOutcome === HiringOutcome.Pending;

    this.params.data.hiringOutcome = hiringOutcome;
    this.params.node.setDataValue("hiringOutcome", hiringOutcome);

    this.params.context.componentParent.QueueOutcomeDecisionUpdate(
      this.params.data.assessmentRequestId,
      hiringOutcome,
      this.params.data.hasAnyAdditionalService
    );

    this.params.api.refreshCells({ rowNodes: [this.params.node], force: true });
  }
}
